//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    searchData: {
      default: () => ({})
    },
    owner: {
      default: () => ({
        loading: false
      })
    }
  },
  data: function () {
    return {
      form: _.extend({}, this.searchData),
      loading: false,
      orderParamsOptions: [
        {value: 'createTime', label: '创建时间'},
        {value: 'updateTime', label: '更新时间'},
        {value: 'publishTime', label: '上架时间'},
        {value: 'dealerCount', label: '经销商数'},
        {value: 'price', label: '售价'}
      ],
      rules: {
      }
    }
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('update:searchData', val)
      },
      deep: true,
      immediate: true
    },
    'owner.loading': {
      handler (val) {
        // console.log('owner.loading', val)
        if (!val) {
          this.loading = false
        }
      },
      immediate: true
    }
  },
  methods: {
    handleFormSubmit () {
      this.$refs.form.validate((valid) => {
        // console.log('data', data)
        this.loading = true
        if (valid) {
          this.$emit('submit', this.form)
        } else {
          this.$notify.error({
            title: '错误',
            message: '表单校验失败'
          })
          return false
        }
      })
    }
  }
}
